(() => {
  function initialize(root) {
    root.querySelectorAll('[data-withdrawal]').forEach((section) => {
      if (section.dataset.ready || section.querySelector('[data-complete]')) return;
      section.dataset.ready = 'true';
      const find = (selector) => section.querySelector(selector);
      const form = find('form');
      const identity = [find('[data-name]'), find('[data-email]'), find('[data-order]')];
      const request = find('[data-request]');
      const selection = find('[data-selection]');
      const message = find('[data-message]');
      const status = find('[data-status]');
      const lookup = find('[data-lookup]');
      const text = find('[data-messages]').dataset;
      let order = null;
      let controller;
      let revision = 0;
      let endpoint;
      try {
        const url = new URL(section.dataset.endpoint, location.origin);
        if (section.dataset.endpoint && url.origin === location.origin && /^\/apps\//.test(url.pathname)) endpoint = url.pathname;
      } catch {}

      function reset() {
        revision++;
        controller?.abort();
        form.querySelectorAll('input[name="contact[body]"]').forEach(input => input.remove());
        message.name = 'contact[body]';
        order = null;
        selection.hidden = true;
        selection.disabled = true;
        find('[data-items]').replaceChildren();
        find('[data-order-title]').textContent = '';
        find('[data-selection-error]').hidden = true;
        lookup.disabled = false;
        request.hidden = Boolean(endpoint);
        request.disabled = Boolean(endpoint);
        message.required = true;
        find('[data-message-label]').textContent = text.labelMessage;
        find('[data-fallback-help]').hidden = false;
        status.textContent = '';
      }

      function fallback(reason) {
        reset();
        request.hidden = false;
        request.disabled = false;
        status.textContent = reason;
      }

      function updateSelection() {
        const all = find('[name=withdrawal_scope]:checked').value === 'all';
        section.querySelectorAll('[data-line]').forEach((row) => {
          const check = row.querySelector('[type=checkbox]');
          const quantity = row.querySelector('[type=number]');
          check.disabled = all;
          quantity.disabled = all || !check.checked;
          if (all) quantity.value = quantity.max;
        });
        find('[data-selection-error]').hidden = true;
      }

      function renderOrder(value) {
        if (typeof value?.name !== 'string' || !Array.isArray(value.items) || !value.items.length || value.items.length > 1000) throw Error('Invalid order');
        const ids = new Set();
        value.items.forEach((item) => {
          if (typeof item.id !== 'string' || ids.has(item.id) || typeof item.title !== 'string' || !Number.isSafeInteger(item.quantity) || item.quantity < 1) throw Error('Invalid item');
          ids.add(item.id);
        });
        order = value;
        find('[data-order-title]').textContent = value.name;
        const rows = value.items.map((item, index) => {
          const row = document.createElement('div');
          row.className = 'naxos-withdrawal__item';
          row.dataset.line = item.id;
          const label = document.createElement('label');
          label.className = 'naxos-withdrawal__choice';
          const checkbox = document.createElement('input');
          checkbox.type = 'checkbox';
          checkbox.checked = true;
          label.append(checkbox, document.createTextNode(item.title));
          const quantityLabel = document.createElement('label');
          quantityLabel.textContent = text.quantity;
          const quantity = document.createElement('input');
          quantity.type = 'number';
          quantity.min = '1';
          quantity.max = String(item.quantity);
          quantity.step = '1';
          quantity.value = String(item.quantity);
          quantity.required = true;
          quantity.id = `${form.id}-quantity-${index}`;
          quantityLabel.htmlFor = quantity.id;
          quantity.setAttribute('aria-label', `${text.quantity}: ${item.title}`);
          quantityLabel.append(quantity);
          row.append(label, quantityLabel);
          return row;
        });
        find('[data-items]').replaceChildren(...rows);
        find('[value=all]').checked = true;
        selection.hidden = false;
        selection.disabled = false;
        request.hidden = false;
        request.disabled = false;
        message.required = false;
        find('[data-message-label]').textContent = text.optionalMessage;
        find('[data-fallback-help]').hidden = true;
        status.textContent = text.matched;
        updateSelection();
      }

      identity.forEach((input) => input.addEventListener('input', () => { input.setCustomValidity(''); reset(); }));
      selection.addEventListener('change', updateSelection);
      find('[data-manual]').addEventListener('click', () => { fallback(''); message.focus(); });
      lookup.addEventListener('click', async () => {
        if (!endpoint) return fallback(text.unavailable);
        for (const input of identity) {
          input.value = input.value.trim();
          if (!input.reportValidity()) return;
        }
        reset();
        const currentRevision = revision;
        controller = new AbortController();
        const currentController = controller;
        const timeout = setTimeout(() => currentController.abort(), 15000);
        lookup.disabled = true;
        status.textContent = text.loading;
        try {
          const response = await fetch(endpoint, {
            method: 'POST', credentials: 'same-origin', cache: 'no-store',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ fullName: identity[0].value, email: identity[1].value, orderNumber: identity[2].value }),
            signal: controller.signal,
          });
          if (currentRevision !== revision) return;
          if (!response.ok) throw Error('Lookup unavailable');
          const result = await response.json();
          if (currentRevision !== revision) return;
          if (result.matched === false) fallback(text.noMatch);
          else if (result.matched === true) renderOrder(result.order);
          else throw Error('Invalid response');
        } catch {
          if (currentRevision === revision) fallback(text.unavailable);
        } finally {
          clearTimeout(timeout);
          if (currentRevision === revision) lookup.disabled = false;
        }
      });

      form.addEventListener('submit', (event) => {
        if (request.hidden) { event.preventDefault(); lookup.click(); return; }
        for (const input of identity) {
          input.setCustomValidity(input.value.trim() ? '' : input.labels[0].textContent);
          if (!input.reportValidity()) { event.preventDefault(); return; }
        }
        if (order) {
          const all = find('[name=withdrawal_scope]:checked').value === 'all';
          const selected = [...section.querySelectorAll('[data-line]')].flatMap((row, index) => {
            if (!all && !row.querySelector('[type=checkbox]').checked) return [];
            const item = order.items[index];
            const quantity = all ? item.quantity : Number(row.querySelector('[type=number]').value);
            return [{ ...item, quantity }];
          });
          if (!selected.length) {
            event.preventDefault();
            find('[data-selection-error]').hidden = false;
            find('[data-items] input').focus();
            return;
          }
          const body = form.querySelector('input[name="contact[body]"]') || document.createElement('input');
          body.type = 'hidden';
          body.name = 'contact[body]';
          body.value = [text.declaration, order.name, all ? text.whole : text.labelItems,
            ...selected.map(item => [
              `${item.quantity} × ${item.title}`,
              `SKU: ${item.sku || '—'}`,
              `Barcode: ${item.barcode || '—'}`,
              ...(item.productUrl ? [`Shop: ${item.productUrl}`] : []),
              '',
            ].join('\n')), message.value].join('\n');
          message.name = 'contact[additional_details]';
          form.append(body);
        }
        find('[data-submitted-at]').value = new Intl.DateTimeFormat('de-DE', {
          timeZone: 'Europe/Berlin', dateStyle: 'long', timeStyle: 'long',
        }).format(new Date());
      });

      window.addEventListener('pageshow', () => {
        form.querySelectorAll('input[name="contact[body]"]').forEach(input => input.remove());
        message.name = 'contact[body]';
      });
      if (endpoint) find('[data-lookup-actions]').hidden = false;
      if (find('[data-server-errors]')) fallback(text.unavailable);
      else reset();
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
